module.exports = __webpack_public_path__ + "img/xzfw.ffc4e253.png";